export default {
  'menu.referrals': '邀请关系管理',
  'pages.referrals.action.detail': '详情',
  'pages.referrals.action.refresh': '刷新',
  'pages.referrals.column.action': '操作',
  'pages.referrals.column.amBitId': 'AmBit ID',
  'pages.referrals.column.avatarUrl': '头像',
  'pages.referrals.column.createdAt': '创建时间',
  'pages.referrals.column.id': 'ID',
  'pages.referrals.column.nickname': '昵称',
  'pages.referrals.column.referred': '被邀请人',
  'pages.referrals.column.referrer': '邀请人',
  'pages.referrals.column.userId': '用户 ID',
  'pages.referrals.detail.referred': '被邀请人',
  'pages.referrals.detail.referrer': '邀请人',
  'pages.referrals.detail.relationship': '邀请关系',
  'pages.referrals.detail.title': '邀请关系详情：{id}',
  'pages.referrals.empty.detail': '暂无数据',
  'pages.referrals.search.referredUserId': '被邀请人用户 ID',
  'pages.referrals.search.referrerUserId': '邀请人用户 ID',
  'pages.referrals.title': '邀请关系管理',
};
